module.exports = __webpack_public_path__ + "static/media/vlplan2.feeb6141.jpeg";